enum ErrorBannerNotificationEnum {
  AccountDefaultAddressUpdate = 'defaultAddressUpdate',
  AccountDeleteAddress = 'accountDeleteAddress',
  AccountDeleteContactSubmit = 'deleteContactSubmit',
  AccountExtendedWarrantyStepSubmit = 'accountExtendedWarrantyStepSubmit',
  AccountExtendedWarrantyProductSearch = 'accountExtendedWarrantyProductSearch',
  AccountExtendedWarrantyRegistrationError = 'accountExtendedWarrantyRegistrationError',
  AccountExtendedWarrantyProofOfPurchaseUploadError = 'accountExtendedWarrantyProofOfPurchaseUploadError',
  AccountExtendedWarrantyProofOfPurchaseDownloadError = 'accountExtendedWarrantyProofOfPurchaseDownloadError',
  AccountGetOrderDetails = 'accountGetOrderDetails',
  CartRemoveItem = 'cartRemoveItem',
  LightboxOuterImages = 'lightboxOuterImages',
  MiniBasketDetails = 'miniBasketDetails',
  NewsletterSignupBanner = 'newsletterSignupBanner',
  NewsletterSignupPopup = 'newsletterSignupPopup',
  OnlineRetailersData = 'onlineRetailersData',
  OrderSummaryRemoveVoucher = 'orderSummaryRemoveVoucher',
  ProductDetailsFetch = 'productDetailsFetch',
  ProductDetailsNotifyMe = 'productDetailsNotifyMe',
  SearchResults = 'searchResults',
  ShippingPickUpLocations = 'shippingPickUpLocations',
}

export default ErrorBannerNotificationEnum;
